module.exports = __webpack_public_path__ + "img/444083093.ac7b3a4c.jpg";